import _Object$assign from "babel-runtime/core-js/object/assign";

var lodashUtils = {
  pluck: function pluck(obj, key) {
    return _.map(obj, function (obj) {
      return obj == null ? void 0 : obj[key];
    });
  },
  findWhere: function findWhere(obj, attrs) {
    return _.find(obj, _.matches(attrs));
  },
  cloneDeepGet: function cloneDeepGet(obj, path, defaultVal) {
    return _.cloneDeep(_.get(obj, path, defaultVal));
  }
};

var load = function load() {
  window._ = window._ && _Object$assign(window._, lodashUtils) || _Object$assign({}, lodashUtils);
};
export default {
  load: load
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/lodash-utils.js
// module id = 1612
// module chunks = 2